"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutUsV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Layout_1 = __importDefault(require("@pages/Layout"));
var section_three_woman_with_phone_png_1 = __importDefault(require("@static/img/png/v2/about-us/section-three-woman-with-phone.png"));
var pillar_1_png_1 = __importDefault(require("@static/img/png/v2/about-us/pillar-1.png"));
var pillar_2_png_1 = __importDefault(require("@static/img/png/v2/about-us/pillar-2.png"));
var pillar_03_png_1 = __importDefault(require("@static/img/png/v2/about-us/pillar-03.png"));
var styles_1 = require("./styles");
var Button_1 = __importDefault(require("@components/Button"));
var ContainerContact_1 = require("@containers/ContainerContact");
var react_router_dom_1 = require("react-router-dom");
var ourPillars = [
    {
        img: pillar_1_png_1.default,
        title: 'Equipo',
        description: 'El trabajo en equipo es nuestro mantra, con sus habilidades y virtudes, cada uno potencia las fortalezas y cualidades de los demás, consolidando el éxito de quienes formamos parte de GBC.',
    },
    {
        img: pillar_2_png_1.default,
        title: 'Pasión',
        description: 'La pasión por lo que hacemos es el corazón de nuestro trabajo, porque sabemos que con esa misma pasión funcionan nuestros clientes. La pasión se contagia y consigue que, lo que parece imposible, se vuelva realidad.',
    },
    {
        img: pillar_03_png_1.default,
        title: 'Curiosidad',
        description: 'Curiosidad por saber qué se viene, cuál será el siguiente paso, a dónde tenemos que mirar. Porque si estamos un paso adelante, nuestros clientes, también lo estarán.',
    },
];
function AboutUsV2() {
    var _a;
    var params = (0, react_router_dom_1.useSearchParams)()[0];
    var section = (_a = params.get('s')) !== null && _a !== void 0 ? _a : null;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var refSec1 = (0, react_1.useRef)(null);
    var refSec2 = (0, react_1.useRef)(null);
    var refSec3 = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (section === null) {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    }, [section]);
    var handleClick = function (ref) {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    (0, react_1.useEffect)(function () {
        if (section !== null) {
            switch (section) {
                case '1':
                    handleClick(refSec1);
                    break;
                case '2':
                    handleClick(refSec2);
                    break;
                case '3':
                    handleClick(refSec3);
                    break;
            }
        }
    }, [section]);
    return ((0, jsx_runtime_1.jsxs)(Layout_1.default, { children: [(0, jsx_runtime_1.jsx)(styles_1.ContainerOne, __assign({ ref: refSec1 }, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContentContainerOne, { children: [(0, jsx_runtime_1.jsxs)("h1", { children: ["Hacemos de la ", (0, jsx_runtime_1.jsx)("span", { children: "tecnolog\u00EDa" }), " nuestra mejor herramienta para conectar con ", (0, jsx_runtime_1.jsx)("span", { children: "nuestros clientes" }), " con", ' ', (0, jsx_runtime_1.jsx)("span", { children: "soluciones de pago" }), " que los ayudan a crecer."] }), (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("span", { children: "GBC" }), " Conectamos con tu negocio"] })] }) })), (0, jsx_runtime_1.jsx)(styles_1.ContainerTwo, __assign({ ref: refSec2 }, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContentContainerTwo, { children: [(0, jsx_runtime_1.jsx)("h1", { children: "En GBC vamos a acelerar tus ventas y hacerte la vida m\u00E1s f\u00E1cil" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Nuestra pasi\u00F3n es acompa\u00F1arte en cada paso de tu viaje empresarial.", ' '] }), (0, jsx_runtime_1.jsx)("p", { children: "Estamos aqu\u00ED para brindarte el soporte, los servicios y la asesor\u00EDa que necesites para cumplir tus metas" }), (0, jsx_runtime_1.jsx)("p", { children: "Nos adaptamos a tus necesidades \u00FAnicas y ser tu socio confiable en el mundo de los pagos y los negocios." })] }) })), (0, jsx_runtime_1.jsxs)(styles_1.ContainerThree, __assign({ ref: refSec3 }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.ContentContainerThreeOne, { children: [(0, jsx_runtime_1.jsx)("img", { src: section_three_woman_with_phone_png_1.default }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Expertos en soluciones de pagos" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Nuestra meta es proporcionarte soluciones tecnol\u00F3gicas que aceleren y optimicen tus ventas.", ' '] }), (0, jsx_runtime_1.jsx)("p", { children: "Cada soluci\u00F3n que facilitamos refleja nuestro compromiso con la excelencia y nuestro deseo de contribuir al crecimiento de tu negocio." }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ variant: "outline", onClick: function () { return navigate('/solutions'); } }, { children: "Conoce nuestras soluciones" }))] })] }), (0, jsx_runtime_1.jsx)(styles_1.ContentContainerThreeTwo, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Nuestros pilares GBC" }), (0, jsx_runtime_1.jsx)(styles_1.ContainerCardPillars, { children: ourPillars.map(function (pillar) { return ((0, jsx_runtime_1.jsxs)(styles_1.CardPillar, { children: [(0, jsx_runtime_1.jsx)("img", { src: pillar.img }), (0, jsx_runtime_1.jsx)("h2", { children: pillar.title }), (0, jsx_runtime_1.jsx)("p", { children: pillar.description })] }, pillar.title)); }) })] }) })] })), (0, jsx_runtime_1.jsx)(ContainerContact_1.ContainerContact, {})] }));
}
exports.AboutUsV2 = AboutUsV2;
